import { type ComponentType, createContext } from "react";

export type PluginMap<K extends object> = Record<keyof K, ComponentType<any>>;

export interface ComponentPluginsContextValue<
  K extends object,
  T extends PluginMap<K>,
> {
  plugins: T;
}

export function createComponentPluginsContext<K extends object>() {
  return createContext<ComponentPluginsContextValue<K, PluginMap<K>>>(null!);
}

export function NoopPlugin() {
  return null;
}
